import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, Button, MenuItem, Collapse, CardContent, Typography, IconButton, Checkbox, FormGroup, FormControlLabel, Select, CardHeader, Card } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
    makeGETRequestOnUserService,
    makePUTRequestOnUserService,
    downloadUserServiceFileUsingGET,
    makeGETRequest,
} from "../../Api/api";
import toastr from "toastr";
import { CircularProgress } from "@material-ui/core";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { downloadPDFFile } from "../../Helpers/functions";

export interface ICkycUserPermissionUsers {
    uuid: string;
    firstName: string;
    lastName: string;
    emailId: string;
    mobileNumber: string;
    type: "superuser" | "admin_user";
}

export interface ActionPayload {
    action: string;
    admin_uuid: string;
    name: string;
    date: string;
    time: string;
    ckyc_number?: string;
};

const CKYCUpdate = ({ data }: { data: any }) => {

    const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");

    const [userCKYC, setUserCKYC] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [ckycPermissionUsers, setCkycPermissionUsers] = useState<ICkycUserPermissionUsers[]>([]);

    const defaultUser = ckycPermissionUsers.find(
        (user) => user.uuid === loginUser.uuid
    );
    const defaultValue = defaultUser
        ? `${defaultUser.uuid}||${defaultUser.firstName}||${defaultUser.lastName}`
        : "";
    const [stateActionBy, setStateActionBy] = useState(defaultValue);
    const [internalStatus, setInternalStatus] = useState("");
    const [stateActionDate, setStateActionDate] = useState("");
    const [stateActionHour, setStateActionHour] = useState("");
    const [stateActionMinute, setStateActionMinute] = useState("");
    const [actionTakenBy, setActionTakenBy] = useState("");
    const [ckycNumber, setCkycNumber] = useState("");
    const [actionDate, setActionDate] = useState("");
    const [actionHour, setActionHour] = useState("");
    const [actionMinute, setActionMinute] = useState("");
    const [fetchStatus, setFetchStatus] = useState("");
    const [modificationType, setModificationType] = useState<string[]>([]);
    const [modificationReview, setModificationReview] = useState("");
    const [modificationFile, setModificationFile] = useState<File | null>(null);
    const [successfulFile, setSuccessfulFile] = useState<File | null>(null);
    const [downloading, setDownloading] = useState({
        fetchModifications: false,
        fetchSuccessfull: false,
        creationModifications: false,
        creationSuccessfull: false
    });
    const [creationStatus, setCreationStatus] = useState("");
    const [creationModificationFile, setCreationModificationFile] = useState<File | null>(null);
    const [creationSuccessfulFile, setCreationSuccessfulFile] = useState<File | null>(null);
    const [duplication, setDuplication] = useState("");
    const [duplicationDate, setDuplicationDate] = useState("");
    const [duplicationHours, setDuplicationHours] = useState("");
    const [duplicationMinute, setDuplicationMinute] = useState("");
    const [duplicationStatus, setDuplicationStatus] = useState("");
    const [duplicationCkycNumber, setDuplicationCkycNumber] = useState("");
    const [duplicationSaved, setDuplicationSaved] = useState(false);
    const [showStatusLog, setShowStatusLog] = useState(false);
    const [showStateActionLog, setShowStateActionLog] = useState(false);
    const [showActionLogs, setShowActionLogs] = useState(false);
    const [showFetchLogs, setShowFetchLogs] = useState(false);
    const [showCreationLogs, setShowCreationLogs] = useState(false);
    const [showFetchStatusLogs, setShowFetchStatusLogs] = useState(false);
    const [showCreationStatusLogs, setShowCreationStatusLogs] = useState(false);
    const [showDuplicationLogs, setShowDuplicationLogs] = useState(false);

    const buildUrl = (endpoint: string, user_type?: string, uuid?: string) => {
        if (!user_type) {
            throw new Error("user_type is missing");
        }

        if (!uuid) {
            throw new Error("uuid is missing");
        }

        return user_type === "smest"
            ? `/kyc/ckyc_detail/${endpoint}/${uuid}/`
            : `/partneruser/ckyc_detail/${endpoint}/${user_type}/${uuid}/`;
    };

    const fetchUsersCKYCDetail = () => {
        setIsLoading(true);

        const user_type = data.user_type;
        const uuid =
            user_type === "smest"
                ? data.userUUID
                : data.ckycUUID;

        const url = buildUrl("list", user_type, uuid);
        makeGETRequestOnUserService(url)
            .then((resp) => {
                if (resp.status === 200) {
                    setUserCKYC(resp.data);
                    setInternalStatus(resp.data.internalStatus || "");
                    setActionTakenBy(resp.data.action || "")
                    setCkycNumber(resp.data.ckycNumber || "")
                    setFetchStatus(resp.data.fetchStatus || "")
                    setModificationType(
                        resp.data.fetchModificationsReview
                            ? resp.data.fetchModificationsReview.split(",")
                            : []
                    );
                    setModificationReview(resp.data.fetchModificationsRemarks || "")
                    setCreationStatus(resp.data.creationStatus || "");
                    setDuplication(resp.data.duplicates || "");
                    setDuplicationStatus(resp.data.deduplicationStatus || "");
                    setDuplicationCkycNumber(resp.data.duplicateCKYCNumber || "");
                }
            })
            .catch(() => toastr.error("Failed to fetch user list."))
            .finally(() => setIsLoading(false));
    };

    const fetchCkycPermissionUsers = () => {
        makeGETRequest("/users/ckyc_permissions/list/")
            .then((resp) => {
                if (resp.status === 200) {
                    setCkycPermissionUsers(resp.data);
                }
            })
            .catch(() => toastr.error("Failed to fetch permission users."));
    };

    useEffect(() => {
        fetchUsersCKYCDetail();
        fetchCkycPermissionUsers();
    }, []);


    useEffect(() => {
        if (ckycPermissionUsers.length > 0 && loginUser.uuid) {
            const defaultUser = ckycPermissionUsers.find(
                (user) => user.uuid === loginUser.uuid
            );
            if (defaultUser) {
                const defaultValue = `${defaultUser.uuid}||${defaultUser.firstName}||${defaultUser.lastName}`;
                setStateActionBy(defaultValue);
            }
        }
    }, [ckycPermissionUsers, loginUser.uuid]);

    const handleInternalStatusSave = async () => {
        if (!internalStatus) {
            toastr.error("Please fill all fields");
            return;
        }
        if (!loginUser?.name || !loginUser?.uuid) {
            toastr.error("Login user information not found");
            return;
        }
        const istDate = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
        const now = new Date(istDate);
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        const hh = String(now.getHours()).padStart(2, "0");
        const min = String(now.getMinutes()).padStart(2, "0");
        setIsLoading(true);
        const payload = {
            internal_status: internalStatus,
            name: loginUser.name,
            admin_uuid: loginUser.uuid,
            date: `${yyyy}-${mm}-${dd}`,
            time: `${hh}:${min}`,
        };
        try {
            const url = buildUrl("internal_status_update", data.user_type, data.ckycUUID);
            const response = await makePUTRequestOnUserService(
                url,
                payload
            );
            toastr.success("cKYC Internal Status Successfully Update");
            fetchUsersCKYCDetail();
        } catch (error) {
            toastr.error("Failed to update cKYC Internal Status status");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveStateAction = () => {
        if (!stateActionBy) {
            toastr.error("Action By is required.")
            return;
        }
        if (!stateActionDate) {
            toastr.error("Action Date is required.")
            return;
        }
        if (!stateActionHour) {
            toastr.error("Action Hour is required.")
            return;
        }
        if (!stateActionMinute) {
            toastr.error("Action Minute is required.")
            return;
        }
        const [admin_uuid, firstName, lastName] = stateActionBy.split("||");
        const hh = stateActionHour.padStart(2, "0");
        const mm = stateActionMinute.padStart(2, "0");
        const payload = {
            admin_uuid,
            name: `${firstName} ${lastName}`,
            date: stateActionDate,
            time: `${hh}:${mm}`,
        };
        setIsLoading(true);
        const url = buildUrl("state_action_update", data.user_type, data.ckycUUID);
        makePUTRequestOnUserService(
            url,
            payload
        )
            .then((resp) => {
                if (resp.status === 200) {
                    toastr.success("CKYC State Action saved successfully");
                    fetchUsersCKYCDetail();
                }
            })
            .catch((err) => {
                toastr.error("Failed to save CKYC State Action");
            })
            .finally(() => setIsLoading(false));
    };

    const handleActionInfo = async () => {
        if (!stateActionBy) {
            toastr.error("Action By is required.")
            return;
        }
        if (!actionDate) {
            toastr.error("Action Date is required.")
            return;
        }
        if (!actionHour) {
            toastr.error("Action Hour is required.")
            return;
        }
        if (!actionMinute) {
            toastr.error("Action Minute is required.")
            return;
        }
        if (actionTakenBy === "Fetched" && !ckycNumber) {
            toastr.error("cKYC Number is required for Fetched.")
            return;
        }
        const [admin_uuid, firstName, lastName] = stateActionBy.split("||");
        const name = `${firstName} ${lastName}`;
        const time = `${actionHour.padStart(2, "0")}:${actionMinute.padStart(2, "0")}`;

        const payload: ActionPayload = {
            action: actionTakenBy,
            admin_uuid,
            name,
            date: actionDate,
            time,
        };
        if (actionTakenBy === "Fetched") {
            payload["ckyc_number"] = ckycNumber;
        }
        setIsLoading(true);
        const url = buildUrl("action_update", data.user_type, data.ckycUUID);
        makePUTRequestOnUserService(
            url,
            payload
        )
            .then((resp) => {
                if (resp.status === 200) {
                    toastr.success("CKYC Action updated  successfully.");
                    fetchUsersCKYCDetail();
                }
            })
            .catch((err) => {
                toastr.error("Failed to save CKYC Action updated");
            })
            .finally(() => setIsLoading(false));
    };

    const handleFetchModificationFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            if (fetchStatus === "Successfully Updated") {
                toastr.warning("Modification file cannot be uploaded when status is 'Successfully Updated'");
                event.target.value = "";
                return;
            }
            const file = event.target.files[0];
            const allowedTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            if (allowedTypes.includes(file.type)) {
                setModificationFile(file);
            } else {
                toastr.error("Only Excel files (xls/xlsx) are allowed.");
                event.target.value = "";
            }
        }
    };

    const handleFetchSuccessfulFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            if (fetchStatus === "Under process with Agency") {
                toastr.warning("Successful file cannot be uploaded when status is 'Under process with Agency'");
                event.target.value = "";
                return;
            }
            const file = event.target.files[0];
            const allowedTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            if (allowedTypes.includes(file.type)) {
                setSuccessfulFile(file);
            } else {
                toastr.error("Only Excel files (xls/xlsx) are allowed.");
                event.target.value = "";
            }
        }
    };

    const handleCheckboxChange = (value: string) => {
        setModificationType((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };

    const handleSaveFetchStatus = async () => {
        try {
            if (!fetchStatus) {
                toastr.error("Please select fetch status");
                return;
            }
            if (modificationType.length === 0) {
                toastr.error("Please select at least one modification type");
                return;
            }
            if (
                modificationType.includes("Others") &&
                !modificationReview.trim()
            ) {
                toastr.error("Please provide remarks for 'Others'");
                return;
            }
            if (fetchStatus === "Under process with Agency") {
                if (!modificationFile && !userCKYC?.fetchModificationsUpload) {
                    toastr.error("Please upload modification proof for 'Under process with Agency' status");
                    return;
                }
                if (successfulFile) {
                    toastr.warning("Successful file will not be uploaded for 'Under process with Agency' status");
                }
            }

            if (fetchStatus === "Successfully Updated") {
                if (!successfulFile && !userCKYC?.fetchSuccessfullUpload) {
                    toastr.error("Please upload successful proof for 'Successfully Updated' status");
                    return;
                }
                if (modificationFile) {
                    toastr.warning("Modification file will not be uploaded for 'Successfully Updated' status");
                }
            }
            const [admin_uuid, firstName, lastName] = stateActionBy.split("||");
            const name = `${firstName} ${lastName}`;
            const istDate = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
            const now = new Date(istDate);
            const yyyy = now.getFullYear();
            const mm = String(now.getMonth() + 1).padStart(2, "0");
            const dd = String(now.getDate()).padStart(2, "0");
            const hh = String(now.getHours()).padStart(2, "0");
            const min = String(now.getMinutes()).padStart(2, "0");
            const date = `${yyyy}-${mm}-${dd}`
            const time = `${hh}:${min}`

            const formData = new FormData();
            formData.append("fetch_status", fetchStatus);
            formData.append("fetch_modifications_review", JSON.stringify(modificationType));

            if (modificationType.includes("Others")) {
                formData.append(
                    "fetch_modifications_remarks",
                    modificationReview
                );
            }
            if (fetchStatus === "Under process with Agency" && modificationFile) {
                formData.append("fetch_modifications_upload", modificationFile);
            }
            if (fetchStatus === "Successfully Updated" && successfulFile) {
                formData.append("fetch_successfully_upload", successfulFile);
            }

            formData.append("name", name);
            formData.append("date", date);
            formData.append("time", time);
            formData.append("admin_uuid", admin_uuid);

            setIsLoading(true);
            const url = buildUrl("fetch_status_update", data.user_type, data.ckycUUID);
            const response = await makePUTRequestOnUserService(
                url,
                formData,
            );

            if (response) {
                toastr.success("Fetch status updated successfully");
                setModificationFile(null);
                setSuccessfulFile(null);
                fetchUsersCKYCDetail();
            }
        } catch (error: any) {
            console.error("Error updating fetch status:", error);
            if (error.response?.data) {
                const errorData = error.response.data;
                if (typeof errorData === 'object') {
                    Object.keys(errorData).forEach(key => {
                        toastr.error(`${key}: ${errorData[key]}`);
                    });
                } else {
                    toastr.error(errorData);
                }
            } else {
                toastr.error("Failed to update fetch status");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownloadFile = async (ckycUUID: string, firstName: string, lastName: string, doc_type: string, doc: string) => {
        const downloadKey = `${doc_type}${doc.charAt(0).toUpperCase() + doc.slice(1)}`;
        try {
            setDownloading(prev => ({ ...prev, [downloadKey]: true }));
            const url = `${buildUrl("download_status_document", data.user_type, data.ckycUUID)}?doc_type=${encodeURIComponent(doc_type)}&doc=${encodeURIComponent(doc)}`;

            const response = await downloadUserServiceFileUsingGET(url);
            if (response && response.status === 200) {
                toastr.success("cKYC Document Downloaded Successfully");
                downloadPDFFile(
                    response.data,
                    `${firstName}_${lastName}_ckyc_${doc_type}_${doc}.xlsx`
                );
            }
        } catch (error) {
            toastr.error("Failed to download file");
        } finally {
            setDownloading(prev => ({ ...prev, [downloadKey]: false }));
        }
    };

    const handleCreationModificationFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            if (creationStatus === "Successfully Updated") {
                toastr.warning("Creation modification file cannot be uploaded when status is 'Successfully Updated'");
                event.target.value = "";
                return;
            }
            const file = event.target.files[0];
            const allowedTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            if (allowedTypes.includes(file.type)) {
                setCreationModificationFile(file);
            } else {
                toastr.error("Only Excel files (xls/xlsx) are allowed.");
                event.target.value = "";
            }
        }
    };

    const handleCreationSuccessfulFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            if (creationStatus === "Under process with Agency") {
                toastr.warning("Creation successful file cannot be uploaded when status is 'Under process with Agency'");
                event.target.value = "";
                return;
            }
            const file = event.target.files[0];
            const allowedTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            if (allowedTypes.includes(file.type)) {
                setCreationSuccessfulFile(file);
            } else {
                toastr.error("Only Excel files (xls/xlsx) are allowed.");
                event.target.value = "";
            }
        }
    };

    const handleSaveCreationStatus = async () => {
        try {
            if (!creationStatus) {
                toastr.error("Please select creation status");
                return;
            }
            if (!ckycNumber.trim()) {
                toastr.error("Please enter cKYC Number");
                return;
            }

            if (creationStatus === "Under process with Agency") {
                if (!creationModificationFile && !userCKYC?.creationModificationsUpload) {
                    toastr.error("Please upload creation proof for 'Under process with Agency' status");
                    return;
                }
                if (creationSuccessfulFile) {
                    toastr.warning("Successful file will not be uploaded for 'Under process with Agency' status");
                }
            }

            if (creationStatus === "Successfully Updated") {
                if (!creationSuccessfulFile && !userCKYC?.creationSuccessfullUpload) {
                    toastr.error("Please upload successful proof for 'Successfully Updated' status");
                    return;
                }
                if (creationModificationFile) {
                    toastr.warning("Creation proof file will not be uploaded for 'Successfully Updated' status");
                }
            }

            const [admin_uuid, firstName, lastName] = stateActionBy.split("||");
            const name = `${firstName} ${lastName}`;
            const istDate = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
            const now = new Date(istDate);
            const yyyy = now.getFullYear();
            const mm = String(now.getMonth() + 1).padStart(2, "0");
            const dd = String(now.getDate()).padStart(2, "0");
            const hh = String(now.getHours()).padStart(2, "0");
            const min = String(now.getMinutes()).padStart(2, "0");
            const date = `${yyyy}-${mm}-${dd}`;
            const time = `${hh}:${min}`;

            const formData = new FormData();
            formData.append("creation_status", creationStatus);
            formData.append("ckyc_number", ckycNumber);

            if (creationStatus === "Under process with Agency" && creationModificationFile) {
                formData.append("creation_modifications_upload", creationModificationFile);
            }

            if (creationStatus === "Successfully Updated" && creationSuccessfulFile) {
                formData.append("creation_successfully_upload", creationSuccessfulFile);
            }

            formData.append("name", name);
            formData.append("date", date);
            formData.append("time", time);
            formData.append("admin_uuid", admin_uuid);

            setIsLoading(true);

            const url = buildUrl("creation_status_update", data.user_type, data.ckycUUID);
            const response = await makePUTRequestOnUserService(
                url,
                formData,
            );

            if (response) {
                toastr.success("Creation status updated successfully");
                setCreationModificationFile(null);
                setCreationSuccessfulFile(null);
                fetchUsersCKYCDetail();
            }
        } catch (error: any) {
            console.error("Error updating creation status:", error);
            if (error.response?.data) {
                const errorData = error.response.data;
                if (typeof errorData === 'object') {
                    Object.keys(errorData).forEach(key => {
                        toastr.error(`${key}: ${errorData[key]}`);
                    });
                } else {
                    toastr.error(errorData);
                }
            } else {
                toastr.error("Failed to update creation status");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveDeduplication = async () => {
        try {
            if (!duplication) {
                toastr.error("Please select duplication status");
                return;
            }
            if (duplication === "Duplication Found" && !duplicationCkycNumber.trim()) {
                toastr.error("Please enter duplicate cKYC number");
                return;
            }

            let date = "";
            let time = "";

            if (duplication === "Duplication Found") {
                if (!duplicationDate) {
                    toastr.error("Please select mail sent date");
                    return;
                }
                if (!duplicationHours || !duplicationMinute) {
                    toastr.error("Please enter time of email");
                    return;
                }
                date = duplicationDate;
                time = `${duplicationHours.padStart(2, "0")}:${duplicationMinute.padStart(2, "0")}`;
            } else {
                const ist = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata", });
                const now = new Date(ist);
                const yyyy = now.getFullYear();
                const mm = String(now.getMonth() + 1).padStart(2, "0");
                const dd = String(now.getDate()).padStart(2, "0");
                const hh = String(now.getHours()).padStart(2, "0");
                const min = String(now.getMinutes()).padStart(2, "0");
                date = `${yyyy}-${mm}-${dd}`;
                time = `${hh}:${min}`;
            }

            const [admin_uuid, firstName, lastName] = stateActionBy.split("||");
            const name = `${firstName} ${lastName}`;

            const payload = {
                duplicates: duplication,
                duplicate_ckyc_number: duplication === "Duplication Found" ? duplicationCkycNumber : "",
                name: name,
                date: date,
                time: time,
                admin_uuid: admin_uuid
            };

            setIsLoading(true);
            const url = buildUrl("deduplication_update", data.user_type, data.ckycUUID);
            const response = await makePUTRequestOnUserService(
                url,
                payload,
            );
            if (response) {
                toastr.success("Deduplication status updated successfully");
                fetchUsersCKYCDetail();
                setDuplicationSaved(true);
            }
        } catch (error: any) {
            console.error("Error updating deduplication status:", error);
            if (error.response?.data) {
                const errorData = error.response.data;
                if (typeof errorData === 'object') {
                    Object.keys(errorData).forEach(key => {
                        toastr.error(`${key}: ${errorData[key]}`);
                    });
                } else {
                    toastr.error(errorData);
                }
            } else {
                toastr.error("Failed to update deduplication status");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveDeduplicationResolved = async () => {
        try {
            if (!duplicationStatus) {
                toastr.error("Please select deduplication status");
                return;
            }

            const [admin_uuid, firstName, lastName] = stateActionBy.split("||");
            const name = `${firstName} ${lastName}`;

            const istDate = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
            const now = new Date(istDate);
            const yyyy = now.getFullYear();
            const mm = String(now.getMonth() + 1).padStart(2, "0");
            const dd = String(now.getDate()).padStart(2, "0");
            const hh = String(now.getHours()).padStart(2, "0");
            const min = String(now.getMinutes()).padStart(2, "0");
            const date = `${yyyy}-${mm}-${dd}`;
            const time = `${hh}:${min}`;

            const payload = {
                deduplication_status: duplicationStatus,
                name: name,
                date: date,
                time: time,
                admin_uuid: admin_uuid
            };

            setIsLoading(true);
            const url = buildUrl("deduplication_resolved_update", data.user_type, data.ckycUUID);
            const response = await makePUTRequestOnUserService(
                url,
                payload,
            );

            if (response) {
                toastr.success("Deduplication resolved status updated successfully");

                if (duplicationStatus === "Duplication Resolved") {
                    toastr.success("Duplicates status automatically set to No Duplicate cKYC");
                }

                fetchUsersCKYCDetail();
            }
        } catch (error: any) {
            console.error("Error updating deduplication resolved status:", error);
            if (error.response?.data) {
                const errorData = error.response.data;
                if (typeof errorData === 'object') {
                    Object.keys(errorData).forEach(key => {
                        toastr.error(`${key}: ${errorData[key]}`);
                    });
                } else {
                    toastr.error(errorData);
                }
            } else {
                toastr.error("Failed to update deduplication resolved status");
            }
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <Box
                sx={{
                    height: "70vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3, bgcolor: "#f3f3f3" }}>

            <Card sx={{ p: 2, mb: 1, borderRadius: 3 }} elevation={2}>
                <CardHeader title="cKYC Information" />
                <CardContent >
                    <div>
                        Full Name of Client as per PAN:{" "}
                        <b>{data.firstName} {data.lastName}</b>
                    </div>
                    <div>
                        SMEST ID: <b>{data.smestID}</b>
                    </div>
                    <div>
                        State:{" "}
                        <b
                            style={{
                                color:
                                    data.addressState?.toLowerCase() === "sikkim"
                                        ? "red"
                                        : "black",
                            }}
                        >
                            {data.addressState}
                        </b>
                    </div>
                    <div>SMEST KYC Approved on: {data.kycMarkedCompletedAt}</div>
                    <div>cKYC Deadline Date: {data.deadlineDate}</div>

                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <div style={{ fontWeight: 600 }}>cKYC Internal Status</div>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Select
                                fullWidth
                                size="small"
                                value={internalStatus}
                                onChange={(e) => setInternalStatus(e.target.value)}
                            >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="Approved">Approved</MenuItem>
                            </Select>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{ height: "40px", textTransform: "none" }}
                                onClick={handleInternalStatusSave}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>

                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "fit-content",
                            }}
                            onClick={() => setShowStatusLog(!showStatusLog)}
                        >
                            <h4 style={{ margin: 0 }}>Status Logs</h4>
                            <IconButton size="small">
                                {showStatusLog ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Box>

                        <Collapse in={showStatusLog} timeout="auto" unmountOnExit>
                            <Box
                                sx={{
                                    maxHeight: "100px",
                                    overflowY: "auto",
                                    pr: 1
                                }}
                            >
                                {userCKYC?.status_log?.length > 0 ? (
                                    userCKYC.status_log.map((log: any) => (
                                        <Typography key={log._id} sx={{ mb: 1 }}>
                                            Status changed to {log.status} by{" "}
                                            {log.name} on {log.date} at {log.time}
                                        </Typography>
                                    ))
                                ) : (
                                    <Typography>No status logs found.</Typography>
                                )}
                            </Box>
                        </Collapse>

                    </Box>
                </CardContent>
            </Card>


            {data.addressState?.toLowerCase() === "sikkim" && (
                <Card sx={{ p: 2, borderRadius: 3, mb: 1, mt: 2 }} elevation={2}>
                    <CardHeader title="State Action Taken Report" />
                    <CardContent >
                        <Box sx={{ mt: 1, fontStyle: "italic" }}>
                            PoI and PoA has been mailed to <b>bse.reports@bseindia.com</b>
                        </Box>

                        <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                            <Grid item xs={12} sm={1.2}>Action Taken By</Grid>

                            <Grid item xs={12} sm={2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={stateActionBy}
                                    onChange={(e) => setStateActionBy(e.target.value)}
                                    disabled={true}
                                >
                                    {ckycPermissionUsers.map((user) => (
                                        <MenuItem
                                            key={user.uuid}
                                            value={`${user.uuid}||${user.firstName}||${user.lastName}`}
                                        >
                                            {user.firstName} {user.lastName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>

                            <Grid item xs={12} sm={1}>Mail Sent On</Grid>

                            <Grid item xs={12} sm={2}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    value={stateActionDate}
                                    onChange={(e) => setStateActionDate(e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={1.8} />

                            <Grid item xs={12} sm={1}>Time of Email</Grid>

                            <Grid item xs={1}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Hours"
                                    type="number"
                                    inputProps={{ min: 0, max: 23 }}
                                    value={stateActionHour}
                                    onChange={(e) => {
                                        let val = Number(e.target.value);
                                        if (val > 23) val = 23;
                                        if (val < 0) val = 0;
                                        setStateActionHour(val.toString());
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={0.5}>Hrs</Grid>

                            <Grid item xs={1}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Minutes"
                                    type="number"
                                    inputProps={{ min: 0, max: 59 }}
                                    value={stateActionMinute}
                                    onChange={(e) => {
                                        let val = Number(e.target.value);
                                        if (val > 59) val = 59;
                                        if (val < 0) val = 0;
                                        setStateActionMinute(val.toString());
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={0.5}>Mins</Grid>
                        </Grid>

                        <Box sx={{ mt: 1 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    width: "fit-content",
                                }}
                                onClick={() => setShowStateActionLog(!showStateActionLog)}
                            >
                                <h4 style={{ margin: 0 }}>State Action Logs</h4>
                                <IconButton size="small">
                                    {showStateActionLog ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>

                            <Collapse in={showStateActionLog} timeout="auto" unmountOnExit>
                                <Box
                                    sx={{
                                        maxHeight: "100px",
                                        overflowY: "auto",
                                        pr: 1,
                                        mt: 1,
                                    }}
                                >
                                    {userCKYC?.state_action_log?.length > 0 ? (
                                        userCKYC.state_action_log.map((log: any) => (
                                            <Typography key={log._id} sx={{ mb: 1 }}>
                                                {log.status} changed by {log.name} on {log.date} at {log.time}
                                            </Typography>
                                        ))
                                    ) : (
                                        <Typography>No status logs found.</Typography>
                                    )}
                                </Box>
                            </Collapse>
                        </Box>

                        <Box sx={{ mt: 1, textAlign: "center" }}>
                            <Button
                                variant="contained"
                                sx={{ px: 5, py: 1.2, textTransform: "none" }}
                                onClick={handleSaveStateAction}
                            >
                                Save
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            )}
            <Card sx={{ p: 2, mb: 1, borderRadius: 3, mt: 2 }} elevation={2}>
                <CardHeader
                    title={
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Box>
                                    Action Taken
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={actionTakenBy}
                                    onChange={(e) => setActionTakenBy(e.target.value)}
                                >
                                    <MenuItem value="Created">cKYC Creation</MenuItem>
                                    <MenuItem value="Fetched">cKYC Fetched</MenuItem>
                                </Select>
                            </Grid>
                        </Grid>
                    }
                    sx={{ pb: 0 }}
                />

                <CardContent >
                    <Box sx={{ mt: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "fit-content",
                            }}
                            onClick={() => setShowActionLogs(!showActionLogs)}
                        >
                            <h4 style={{ margin: 0 }}>Action Logs</h4>
                            <IconButton size="small">
                                {showActionLogs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Box>

                        <Collapse in={showActionLogs} timeout="auto" unmountOnExit>
                            <Box
                                sx={{
                                    mt: 1,
                                    maxHeight: "100px",
                                    overflowY: "auto",
                                    pr: 1
                                }}
                            >
                                {userCKYC?.action_log?.length > 0 ? (
                                    userCKYC.action_log.map((log: any) => (
                                        <Typography key={log._id}>
                                            Action changed to cKYC {log.status} changed to by {log.name} on{" "} {log.date} at {log.time}
                                        </Typography>
                                    ))
                                ) : (
                                    <Typography>No status logs found.</Typography>
                                )}
                            </Box>
                        </Collapse>
                    </Box>

                    <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                        {actionTakenBy === "Fetched" && (
                            <>
                                <Grid item xs={12} sm={3}><h2>cKYC Fetched Information</h2></Grid>
                                <Grid item xs={12} sm={8}>
                                    <Typography sx={{ color: "red" }}>
                                        Fetching a clients KYC more then once will trigger an alarm, proceed with caution
                                    </Typography>
                                </Grid>
                            </>
                        )}
                        {actionTakenBy === "Created" && (
                            <Grid item xs={12} sm={3}><h2>cKYC Creation Information</h2></Grid>
                        )}
                    </Grid>

                    {actionTakenBy === "Fetched" && (
                        <>
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={1.2}>cKYC Number*</Grid>
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={ckycNumber}
                                        onChange={(e) => setCkycNumber(e.target.value)}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {actionTakenBy && (
                        <>
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                {actionTakenBy === "Fetched" && (
                                    <Grid item xs={12} sm={1.2}>Fetched By*</Grid>
                                )}

                                {actionTakenBy === "Created" && (
                                    <Grid item xs={12} sm={1.2}>Created By*</Grid>
                                )}

                                <Grid item xs={12} sm={2}>
                                    <Select
                                        fullWidth
                                        size="small"
                                        value={stateActionBy}
                                        onChange={(e) => setStateActionBy(e.target.value)}
                                        disabled={true}
                                    >
                                        {ckycPermissionUsers.map((user) => (
                                            <MenuItem
                                                key={user.uuid}
                                                value={`${user.uuid}||${user.firstName}||${user.lastName}`}
                                            >
                                                {user.firstName} {user.lastName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                {actionTakenBy === "Fetched" && (
                                    <Grid item xs={12} sm={1}>Fetched Date*</Grid>
                                )}
                                {actionTakenBy === "Created" && (
                                    <Grid item xs={12} sm={1}>Created Date*</Grid>
                                )}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        value={actionDate}
                                        onChange={(e) => setActionDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={1.8}></Grid>
                                {actionTakenBy === "Fetched" && (
                                    <Grid item xs={12} sm={1}>Fetched Time*</Grid>
                                )}
                                {actionTakenBy === "Created" && (
                                    <Grid item xs={12} sm={1}>Created Time*</Grid>
                                )}
                                <Grid item xs={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Hours"
                                        type="number"
                                        inputProps={{ min: 0, max: 23 }}
                                        value={actionHour}
                                        onChange={(e) => {
                                            let val = Number(e.target.value);
                                            if (val > 23) val = 23;
                                            if (val < 0) val = 0;
                                            setActionHour(val.toString());
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={0.5}> Hrs</Grid>
                                <Grid item xs={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Minutes"
                                        type="number"
                                        inputProps={{ min: 0, max: 59 }}
                                        value={actionMinute}
                                        onChange={(e) => {
                                            let val = Number(e.target.value);
                                            if (val > 59) val = 59;
                                            if (val < 0) val = 0;
                                            setActionMinute(val.toString());
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={0.5}> Mins</Grid>
                            </Grid>
                        </>
                    )}

                    {actionTakenBy === "Fetched" && (
                        <>
                            <Box sx={{ mt: 1 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        width: "fit-content",
                                    }}
                                    onClick={() => setShowFetchLogs(!showFetchLogs)}
                                >
                                    <h4 style={{ margin: 0 }}>Fetch Logs</h4>
                                    <IconButton size="small">
                                        {showFetchLogs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                </Box>

                                <Collapse in={showFetchLogs} timeout="auto" unmountOnExit>
                                    <Box
                                        sx={{
                                            mt: 1,
                                            maxHeight: "100px",
                                            overflowY: "auto",
                                            pr: 1
                                        }}
                                    >
                                        {(() => {
                                            const createdLogs =
                                                userCKYC?.action_log?.filter((log: any) => log.status === "Fetched") || [];

                                            if (createdLogs.length === 0) {
                                                return <Typography>No status logs found.</Typography>;
                                            }

                                            return createdLogs.map((log: any) => (
                                                <Typography key={log._id}>
                                                    cKYC {log.status} by {log.name} on {log.date} at {log.time}
                                                </Typography>
                                            ));
                                        })()}
                                    </Box>
                                </Collapse>
                            </Box>
                        </>
                    )}

                    {actionTakenBy === "Created" && (
                        <>
                            <Box sx={{ mt: 1 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        width: "fit-content",
                                    }}
                                    onClick={() => setShowCreationLogs(!showCreationLogs)}
                                >
                                    <h4 style={{ margin: 0 }}>Creation Logs</h4>
                                    <IconButton size="small">
                                        {showCreationLogs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                </Box>

                                <Collapse in={showCreationLogs} timeout="auto" unmountOnExit>
                                    <Box
                                        sx={{
                                            mt: 1,
                                            maxHeight: "100px",
                                            overflowY: "auto",
                                            pr: 1
                                        }}
                                    >
                                        {(() => {
                                            const createdLogs =
                                                userCKYC?.action_log?.filter((log: any) => log.status === "Created") || [];

                                            if (createdLogs.length === 0) {
                                                return <Typography>No status logs found.</Typography>;
                                            }

                                            return createdLogs.map((log: any) => (
                                                <Typography key={log._id}>
                                                    cKYC {log.status} by {log.name} on {log.date} at {log.time}
                                                </Typography>
                                            ));
                                        })()}
                                    </Box>
                                </Collapse>
                            </Box>
                        </>
                    )}

                    {actionTakenBy && (
                        <>
                            <Box sx={{ mt: 1, textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    sx={{ px: 5, py: 1.2, textTransform: "none" }}
                                    onClick={handleActionInfo}
                                >
                                    Save
                                </Button>
                            </Box>
                        </>
                    )}
                </CardContent>
            </Card>
            {actionTakenBy === "Fetched" && (
                <>
                    <Card sx={{ p: 2, mb: 1, borderRadius: 3, mt: 2 }} elevation={2}>
                        <CardHeader
                            title={
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={3}>
                                        <Box>
                                            cKYC Fetch Status
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <Select
                                            fullWidth
                                            size="small"
                                            value={fetchStatus}
                                            onChange={(e) => setFetchStatus(e.target.value)}
                                        >
                                            <MenuItem value="Under process with Agency">Under process with Agency</MenuItem>
                                            <MenuItem value="Successfully Updated">Successfully Updated</MenuItem>
                                        </Select>
                                    </Grid>
                                </Grid>
                            }
                            sx={{ pb: 0 }}
                        />
                        <CardContent >
                            <Box sx={{ mt: 1 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        width: "fit-content",
                                    }}
                                    onClick={() => setShowFetchStatusLogs(!showFetchStatusLogs)}
                                >
                                    <h4 style={{ margin: 0 }}>Fetch Status Logs</h4>
                                    <IconButton size="small">
                                        {showFetchStatusLogs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                </Box>

                                <Collapse in={showFetchStatusLogs} timeout="auto" unmountOnExit>
                                    <Box
                                        sx={{
                                            mt: 1,
                                            maxHeight: "100px",
                                            overflowY: "auto",
                                            pr: 1
                                        }}
                                    >
                                        {userCKYC?.fetch_status_log?.length > 0 ? (
                                            userCKYC.fetch_status_log.map((log: any) => (
                                                <Typography key={log._id}>
                                                    Fetch Status log was changed to {log.status} by {log.name} on{" "} {log.date} {log.time}
                                                </Typography>
                                            ))
                                        ) : (
                                            <Typography>No status logs found.</Typography>
                                        )}
                                    </Box>
                                </Collapse>
                            </Box>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={4}><h2>Modifications under review</h2></Grid>
                            </Grid>

                            <Box>
                                <FormGroup row>
                                    {[
                                        "Name",
                                        "PAN",
                                        "Address",
                                        "Date of Birth",
                                        "Gender",
                                        "Email",
                                        "Mobile",
                                        "Others",
                                    ].map((item) => (
                                        <FormControlLabel
                                            key={item}
                                            control={
                                                <Checkbox
                                                    checked={modificationType.includes(item)}
                                                    onChange={() =>
                                                        handleCheckboxChange(item)
                                                    }
                                                />
                                            }
                                            label={item}
                                        />
                                    ))}
                                </FormGroup>
                            </Box>

                            {modificationType.includes("Others") && (
                                <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                    <Grid item xs={12} sm={10}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Mandatory remarks if others"
                                            value={modificationReview}
                                            onChange={(e) => setModificationReview(e.target.value)}
                                        >
                                        </TextField>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Upload modification proof cKYC (excel)*</Grid>
                                <Grid item xs={12} sm={0.5}>
                                    <input
                                        accept=".xls,.xlsx"
                                        style={{ display: 'none' }}
                                        id="modification-file-upload"
                                        type="file"
                                        onChange={handleFetchModificationFileChange}
                                        disabled={fetchStatus === "Successfully Updated"}
                                    />
                                    <label htmlFor="modification-file-upload">
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            component="span"
                                            disabled={fetchStatus === "Successfully Updated"}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    {modificationFile ? modificationFile.name :
                                        userCKYC?.fetchModificationsUpload || "No File Name Found"}
                                </Grid>
                                {userCKYC?.fetchModificationsUpload && (
                                    <Grid item xs={12} sm={0.5}>
                                        <IconButton
                                            size="small"
                                            sx={{ color: "green" }}
                                            onClick={() => !downloading.fetchModifications &&
                                                handleDownloadFile(data.ckycUUID, data.firstName, data.lastName, "fetch", "modifications")
                                            }
                                            disabled={downloading.fetchModifications}
                                        >
                                            {downloading.fetchModifications ? <CircularProgress size={18} /> : <DownloadForOfflineIcon />}
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Upload successfull proof cKYC (excel)*</Grid>
                                <Grid item xs={12} sm={0.5}>
                                    <input
                                        accept=".xls,.xlsx"
                                        style={{ display: 'none' }}
                                        id="successful-file-upload"
                                        type="file"
                                        onChange={handleFetchSuccessfulFileChange}
                                        disabled={fetchStatus === "Under process with Agency"}
                                    />
                                    <label htmlFor="successful-file-upload">
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            component="span"
                                            disabled={fetchStatus === "Under process with Agency"}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    {successfulFile ? successfulFile.name :
                                        userCKYC?.fetchSuccessfullUpload || "No File Name Found"}
                                </Grid>
                                {userCKYC?.fetchSuccessfullUpload && (
                                    <Grid item xs={12} sm={0.5}>
                                        <IconButton
                                            size="small"
                                            sx={{ color: "green" }}
                                            onClick={() => !downloading.fetchSuccessfull &&
                                                handleDownloadFile(data.ckycUUID, data.firstName, data.lastName, "fetch", "successfull")
                                            }
                                            disabled={downloading.fetchSuccessfull}
                                        >
                                            {downloading.fetchSuccessfull ? <CircularProgress size={18} /> : <DownloadForOfflineIcon />}
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>

                            <Box sx={{ mt: 1, textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    sx={{ px: 5, py: 1.2, textTransform: "none" }}
                                    onClick={handleSaveFetchStatus}
                                >
                                    Save
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </>
            )}

            {actionTakenBy === "Created" && (
                <>
                    <Card sx={{ p: 2, mb: 1, borderRadius: 3, mt: 2 }} elevation={2}>
                        <CardHeader
                            title={
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={3}>
                                        <Box>
                                            cKYC Creation Status
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <Select
                                            fullWidth
                                            size="small"
                                            value={creationStatus}
                                            onChange={(e) => setCreationStatus(e.target.value)}
                                        >
                                            <MenuItem value="Under process with Agency">Under process with Agency</MenuItem>
                                            <MenuItem value="Successfully Updated">Successfully Updated</MenuItem>
                                        </Select>
                                    </Grid>
                                </Grid>
                            }
                            sx={{ pb: 0 }}
                        />
                        <CardContent >
                            <Box sx={{ mt: 1 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        width: "fit-content",
                                    }}
                                    onClick={() => setShowCreationStatusLogs(!showCreationStatusLogs)}
                                >
                                    <h4 style={{ margin: 0 }}>Creation Status Logs</h4>
                                    <IconButton size="small">
                                        {showCreationStatusLogs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                </Box>

                                <Collapse in={showCreationStatusLogs} timeout="auto" unmountOnExit>
                                    <Box
                                        sx={{
                                            mt: 1,
                                            maxHeight: "100px",
                                            overflowY: "auto",
                                            pr: 1
                                        }}
                                    >
                                        {userCKYC?.creation_status_log?.length > 0 ? (
                                            userCKYC.creation_status_log.map((log: any) => (
                                                <Typography key={log._id}>
                                                    Creation Status log was changed to {log.status} by {log.name} on{" "} {log.date} {log.time}
                                                </Typography>
                                            ))
                                        ) : (
                                            <Typography>No status logs found.</Typography>
                                        )}
                                    </Box   >
                                </Collapse>
                            </Box>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Upload creation proof cKYC (excel)*</Grid>
                                <Grid item xs={12} sm={0.5}>
                                    <input
                                        accept=".xls,.xlsx"
                                        style={{ display: 'none' }}
                                        id="modification-file-upload"
                                        type="file"
                                        onChange={handleCreationModificationFileChange}
                                        disabled={creationStatus === "Successfully Updated"}
                                    />
                                    <label htmlFor="modification-file-upload">
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            component="span"
                                            disabled={creationStatus === "Successfully Updated"}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    {creationModificationFile ? creationModificationFile.name :
                                        userCKYC?.creationModificationsUpload || "No File Name Found"}
                                </Grid>
                                {userCKYC?.creationModificationsUpload && (
                                    <Grid item xs={12} sm={0.5}>
                                        <IconButton
                                            size="small"
                                            sx={{ color: "green" }}
                                            onClick={() => !downloading.creationModifications &&
                                                handleDownloadFile(data.ckycUUID, data.firstName, data.lastName, "creation", "modifications")
                                            }
                                            disabled={downloading.creationModifications}
                                        >
                                            {downloading.creationModifications ? <CircularProgress size={18} /> : <DownloadForOfflineIcon />}
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Upload successfull proof cKYC (excel)*</Grid>
                                <Grid item xs={12} sm={0.5}>
                                    <input
                                        accept=".xls,.xlsx"
                                        style={{ display: 'none' }}
                                        id="successful-file-upload"
                                        type="file"
                                        onChange={handleCreationSuccessfulFileChange}
                                        disabled={creationStatus === "Under process with Agency"}
                                    />
                                    <label htmlFor="successful-file-upload">
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            component="span"
                                            disabled={creationStatus === "Under process with Agency"}
                                        >
                                            <CloudUploadIcon />
                                        </IconButton>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    {creationSuccessfulFile ? creationSuccessfulFile.name :
                                        userCKYC?.creationSuccessfullUpload || "No File Name Found"}
                                </Grid>
                                {userCKYC?.creationSuccessfullUpload && (
                                    <Grid item xs={12} sm={0.5}>
                                        <IconButton
                                            size="small"
                                            sx={{ color: "green" }}
                                            onClick={() => !downloading.creationSuccessfull &&
                                                handleDownloadFile(data.ckycUUID, data.firstName, data.lastName, "creation", "successfull")
                                            }
                                            disabled={downloading.creationSuccessfull}
                                        >
                                            {downloading.creationSuccessfull ? <CircularProgress size={18} /> : <DownloadForOfflineIcon />}
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>cKYC Number</Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={ckycNumber}
                                        onChange={(e) => setCkycNumber(e.target.value)}
                                    >
                                    </TextField>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 1, textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    sx={{ px: 5, py: 1.2, textTransform: "none" }}
                                    onClick={handleSaveCreationStatus}
                                >
                                    Save
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </>
            )}


            <Card sx={{ p: 2, mb: 1, borderRadius: 3, mt: 2 }} elevation={2}>
                <CardHeader
                    title={
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Box>
                                    Deduplication Actions
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={duplication}
                                    onChange={(e) => setDuplication(e.target.value)}
                                >
                                    <MenuItem value="Duplication Found">Duplication Found</MenuItem>
                                    <MenuItem value="No Duplicate cKYC">No Duplicate cKYC</MenuItem>
                                </Select>
                            </Grid>
                        </Grid>
                    }
                    sx={{ pb: 0 }}
                />

                <CardContent >
                    <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={1.2}>Action Taken By*</Grid>
                        <Grid item xs={12} sm={2}>
                            <Select
                                fullWidth
                                size="small"
                                value={stateActionBy}
                                onChange={(e) => setStateActionBy(e.target.value)}
                                disabled={true}
                            >
                                {ckycPermissionUsers.map((user) => (
                                    <MenuItem
                                        key={user.uuid}
                                        value={`${user.uuid}||${user.firstName}||${user.lastName}`}
                                    >
                                        {user.firstName} {user.lastName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        {duplication === "Duplication Found" && (
                            <>
                                <Grid item xs={12} sm={1}>Updated on Portal</Grid>
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        value={duplicationDate}
                                        onChange={(e) => setDuplicationDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={1.8}></Grid>
                                <Grid item xs={12} sm={1}>Time of Email</Grid>
                                <Grid item xs={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Hours"
                                        type="number"
                                        inputProps={{ min: 0, max: 23 }}
                                        value={duplicationHours}
                                        onChange={(e) => {
                                            let val = Number(e.target.value);
                                            if (val > 23) val = 23;
                                            if (val < 0) val = 0;
                                            setDuplicationHours(val.toString());
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={0.5}> Hrs</Grid>
                                <Grid item xs={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Minutes"
                                        type="number"
                                        inputProps={{ min: 0, max: 59 }}
                                        value={duplicationMinute}
                                        onChange={(e) => {
                                            let val = Number(e.target.value);
                                            if (val > 59) val = 59;
                                            if (val < 0) val = 0;
                                            setDuplicationMinute(val.toString());
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={0.5}> Mins</Grid>
                            </>
                        )}
                    </Grid>

                    <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={3}>Original cKYC Number</Grid>
                        <Grid item xs={12} sm={3}>{ckycNumber}</Grid>
                    </Grid>

                    {duplication === "Duplication Found" && (
                        <>
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Duplicate cKYC Number*</Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={duplicationCkycNumber}
                                        onChange={(e) => setDuplicationCkycNumber(e.target.value)}
                                        placeholder="Enter duplicate cKYC number"
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}

                    <Box sx={{ mt: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "fit-content",
                            }}
                            onClick={() => setShowDuplicationLogs(!showDuplicationLogs)}
                        >
                            <h4 style={{ margin: 0 }}>Duplication Logs</h4>
                            <IconButton size="small">
                                {showDuplicationLogs ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Box>

                        <Collapse in={showDuplicationLogs} timeout="auto" unmountOnExit>
                            <Box
                                sx={{
                                    mt: 1,
                                    maxHeight: "100px",
                                    overflowY: "auto",
                                    pr: 1
                                }}
                            >
                                {userCKYC?.deduplication_log?.length > 0 ? (
                                    userCKYC.deduplication_log.map((log: any) => (
                                        <Typography key={log._id}>
                                            {log.status} changed to by {log.name} on{" "} {log.date} at {log.time}
                                        </Typography>
                                    ))
                                ) : (
                                    <Typography>No status logs found.</Typography>
                                )}
                            </Box>
                        </Collapse>
                    </Box>

                    <Box sx={{ mt: 1, textAlign: "center" }}>
                        <Button
                            variant="contained"
                            sx={{ px: 5, py: 1.2, textTransform: "none" }}
                            onClick={handleSaveDeduplication}
                        >
                            Save
                        </Button>
                    </Box>

                    {duplicationSaved && duplicationCkycNumber && (
                        <>
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>
                                    <Select
                                        fullWidth
                                        size="small"
                                        value={duplicationStatus}
                                        onChange={(e) => setDuplicationStatus(e.target.value)}
                                    >
                                        <MenuItem value="Duplication Query in Process">Duplication Query in Process</MenuItem>
                                        <MenuItem value="Duplication Resolved">Duplication Resolved</MenuItem>
                                    </Select>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Original cKYC Number</Grid>
                                <Grid item xs={12} sm={3}>{ckycNumber || ""}</Grid>
                            </Grid>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={3}>Deleted Duplicate cKYC Number</Grid>
                                <Grid item xs={12} sm={3}><Typography sx={{ color: "red" }}>{duplicationCkycNumber || ""}</Typography></Grid>
                            </Grid>

                            <Box sx={{ mt: 1, textAlign: "center" }}>
                                <Button
                                    variant="contained"
                                    sx={{ px: 5, py: 1.2, textTransform: "none" }}
                                    onClick={handleSaveDeduplicationResolved}
                                >
                                    Save
                                </Button>
                            </Box>
                        </>
                    )}
                </CardContent>

            </Card>
        </Box>
    );
};

export default CKYCUpdate;
